import React from 'react'
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import {ShortStatistikArea} from "./ligaComponents";
import {Gesamtstatistik} from "./../statistics/StatisticGameComponents";
import {Card} from "primereact/card";
import PropTypes from "prop-types";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";

class DoppelStatisticArea extends React.Component {

    constructor(props) {
        super(props);
        this.state = {gesamtStatistik: {}, statistikLetzte30Tage: {}};

        this.showInfo = this.showInfo.bind(this);
        this.showError = this.showError.bind(this);
        this.ladeDaten = this.ladeDaten.bind(this);
    }

    componentDidMount() {
        this.ladeDaten();
    }

    ladeDaten() {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.statistics + "/doppelstatistik?doppelpartnerid=" + this.props.doppelpartnerid,
            json => {
                this.setState({...json});
            },
            responseNotOk => {
                this.showError("Fehler: " + responseNotOk.message);
            },
            error => {
                this.showError("Fehler: " + error.message);
            }
        );
    }

    showInfo(message) {
        this.setState({infoMessage: message});
    }

    showError(message) {
        this.setState({errorMessage: message});
    }

    render() {
        return <div
            style={{textAlign: "center", align: "center", backgroundColor: "white", color: "black"}}>
            <ErrorInfoComponent errorMessage={this.state.errorMessage} infoMessage={this.state.infoMessage} warnMessage={this.state.warnMessage}
                                onClearInfoMessage={() => this.setState({infoMessage: undefined})}
                                onClearErrorMessage={() => this.setState({errorMessage:undefined})}
                                onClearWarnMessage={() => this.setState({warnMessage: undefined})}/>
            <div className="pageHeader" style={{backgroundColor: "#ff99c2"}}>
                Statistik
            </div>
            <div className="grid" style={{textAlign: "left", padding: 20, margin: 0}}>
                <div className="col" style={{marginRight: 10}}>
                    <div style={{border: "1px solid #ddd", padding:10}}>
                        <ShortStatistikArea statistik={this.state.gesamtStatistik} label="Gesamt"/>
                        <span style={{marginLeft: 20, cursor: "pointer"}} onClick={() => this.setState({
                            selectedStatistik: this.state.gesamtStatistik,
                            selectedLabel: "Gesamtstatistik"
                        })}>
                                Details anzeigen....</span>
                    </div>
                </div>
                <div className="col" style={{marginRight: 10}}>
                    <div style={{border: "1px solid #ddd", padding: 10}}>
                        <ShortStatistikArea statistik={this.state.heute} label="Heute"/>
                        <span style={{marginLeft: 20, cursor: "pointer"}} onClick={() => this.setState({
                            selectedStatistik: this.state.heute,
                            selectedLabel: "Statistik heute"
                        })}>
                        Details anzeigen....</span>
                    </div>
                </div>
                <div className="col" style={{marginRight: 10}}>
                    <div style={{border: "1px solid #ddd", padding: 10}}>
                        <ShortStatistikArea statistik={this.state.dreissigTage} label="Letzte 30 Tage"/>
                        <span style={{marginLeft: 20, cursor: "pointer"}} onClick={() => this.setState({
                            selectedStatistik: this.state.dreissigTage,
                            selectedLabel: "Statistik letzte 30 Tage"
                        })}>
                        Details anzeigen....</span>
                    </div>
                </div>
                <div className="col" style={{marginRight: 10}}>
                    <div style={{border: "1px solid #ddd", padding: 10}}>
                        <ShortStatistikArea statistik={this.state.diesesJahr} label="Dieses Jahr"/>
                        <span style={{marginLeft: 20, cursor: "pointer"}} onClick={() => this.setState({
                            selectedStatistik: this.state.diesesJahr,
                            selectedLabel: "Statistik dieses Jahr"
                        })}>
                        Details anzeigen....</span>
                    </div>
                </div>
                <div className="col" style={{marginRight: 10}}>
                    <div style={{border: "1px solid #ddd", padding: 10}}>
                        <ShortStatistikArea statistik={this.state.letztesJahr} label="Letztes Jahr"/>
                        <span style={{marginLeft: 20, cursor: "pointer"}} onClick={() => this.setState({
                            selectedStatistik: this.state.letztesJahr,
                            selectedLabel: "Statistik letztes Jahr"
                        })}>
                        Details anzeigen....</span>
                    </div>
                </div>
            </div>
            {this.state.selectedStatistik !== null && this.state.selectedStatistik !== undefined &&
            <div style={{textAlign: "left", padding: 20, margin: 0}}>
                <Gesamtstatistik data={this.state.selectedStatistik} ueberschrift={this.state.selectedLabel}/>
            </div>
            }

        </div>
    }

    y
}

DoppelStatisticArea.propTypes = {
    doppelpartnerid: PropTypes.string.isRequired,
};

export default DoppelStatisticArea